// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__Cfxdq","logo_center":"logo_logo_center__X1pbm","logo_link":"logo_logo_link__vtmKA","logo_icon":"logo_logo_icon__QxeSz","logo_default":"logo_logo_default__WP5OZ"};